import { render, staticRenderFns } from "./PortfolioGraphContainer.vue?vue&type=template&id=a0bff6e0&"
import script from "./PortfolioGraphContainer.vue?vue&type=script&lang=ts&"
export * from "./PortfolioGraphContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports